import { useStaticSWR } from './swr'

export const useGetOpenDocumentSlideHeaderTooltip = () => {
  return useStaticSWR<boolean | undefined>('useOpenDocumentSlideHeaderTooltip', undefined)
}
